// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-style-loader!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/css-loader?{"minimize":true,"sourceMap":true}!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-24cd131a","scoped":false,"hasInlineConfig":false}!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 672
// module chunks = 29